<template>
  <div>
    <el-row :gutter="20" v-loading="loading">
      <el-col :xl="14" :lg="24">
        <el-row class="mb10">
          <el-card>
            <div slot="header" class="header-wrap">
              <span>{{ $t('customer::customer-list::basic_info') }}</span>
              <!-- <el-button icon="el-icon-edit" @click="visiable = true">
                {{ $t('customer::customer-list::edit') }}
              </el-button> -->
            </div>
            <div style="padding: 24px 8px; display: flex; flex-wrap: wrap">
              <div class="line-item" style="margin-bottom: 32px; width: 100%">
                <div class="line-left">
                  <span>*</span>
                  {{ $t('customer::customer-list::email') }}：
                </div>
                <div class="content">{{ $dataCheck(customerDetail.userEmail) }}</div>
              </div>
              <div class="line-item" style="margin-bottom: 32px">
                <div class="line-left">
                  <span>*</span>
                  {{ $t('customer::customer-list::last_name') }}：
                </div>
                <div class="content">{{ $dataCheck(customerDetail.lastName) }}</div>
              </div>
              <div class="line-item" style="margin-bottom: 32px">
                <div class="line-left">
                  <span>*</span>
                  {{ $t('customer::customer-list::first_name') }}：
                </div>
                <div class="content">{{ $dataCheck(customerDetail.firstName) }}</div>
              </div>
              <div class="line-item">
                <div class="line-left">{{ $t('customer::customer-list::phone') }}：</div>
                <div class="content">{{ $dataCheck(customerDetail.phone) }}</div>
              </div>
              <div class="line-item">
                <div class="line-left">{{ $t('customer::customer-list::顾客来源') }}：</div>
                <div class="content">{{ $dataCheck(customerDetail.firstChannel) }}</div>
              </div>
              <!-- <div class="line-item ">
                <div class="line-left">{{ $t('customer::customer-list::customer_level') }}：</div>
                <div class="content">{{ $dataCheck(customerDetail.customerLevelName) }}</div>
              </div>
              <div class="line-item ">
                <div class="line-left">{{ $t('customer::customer-list::是否订阅') }}：</div>
                <el-checkbox :value="!!customerDetail.acceptsMarketing" @change="editMarket"></el-checkbox>
              </div> -->
            </div>
            <!-- <el-row style="padding:24px 8px;">
              <el-col :span="8" class="line-item " style="margin-bottom:32px">
                <div class="line-left">
                  <span>*</span>
                  {{ $t('customer::customer-list::email') }}：
                </div>
                <div class="content">{{ $dataCheck(customerDetail.email) }}</div>
              </el-col>
              <el-col :span="8" class="line-item " style="margin-bottom:32px">
                <div class="line-left">
                  <span>*</span>
                  {{ $t('customer::customer-list::last_name') }}：
                </div>
                <div class="content">{{ $dataCheck(customerDetail.lastName) }}</div>
              </el-col>
              <el-col :span="8" class="line-item " style="margin-bottom:32px">
                <div class="line-left">
                  <span>*</span>
                  {{ $t('customer::customer-list::first_name') }}：
                </div>
                <div class="content">{{ $dataCheck(customerDetail.firstName) }}</div>
              </el-col>
              <el-col :span="8" class="line-item">
                <div class="line-left">{{ $t('customer::customer-list::phone') }}：</div>
                <div class="content">{{ $dataCheck(customerDetail.phone) }}</div>
              </el-col>
              <el-col :span="8" class="line-item">
                <div class="line-left">{{ $t('customer::customer-list::customer_level') }}：</div>
                <div class="content">{{ $dataCheck(customerDetail.customerLevelName) }}</div>
              </el-col>
              <el-col :span="8" class="line-item">
                <div class="line-left">{{ '是否订阅：' }}</div>
                <el-checkbox :value="!!customerDetail.acceptsMarketing" @change="editMarket"></el-checkbox>
                {{ $t('customer::customer-list::has_subscribe') }}
              </el-col>
            </el-row> -->
          </el-card>
        </el-row>
        <el-row class="mb10">
          <el-card>
            <div slot="header" class="header-wrap">
              <span>{{ $t('customer::customer-list::registered_status') }}</span>
            </div>
            <div style="padding: 16px 8px">
              <el-row class="shop-line" v-for="item in customerDetail.shopCustomerInfos" :key="item.id">
                <!-- <el-col :span="6">{{ $t('customer::customer-list::shop_name') }}：{{ $dataCheck(item.brandName) }}</el-col> -->
                <el-col :span="3">
                  <span class="shop-main" style="font-weight: bold">{{ $dataCheck(item.brandName) }}</span>
                </el-col>
                <el-col :span="5">
                  <span class="shop-main">{{ $dataCheck(item.domain) }}</span>
                </el-col>
                <el-col :span="3">
                  {{ $t('customer::customer-list::buy_count') }}：{{ $dataCheck(item.orderNum) }}
                </el-col>
                <el-col :span="5">
                  {{ $t('customer::customer-list::grand_total') }}：{{ $dataCheck(formatNumberMix(item.ltv, 2)) }} USD
                </el-col>
                <el-col :span="8">
                  {{ $t('customer::customer-list::join_time') }}：{{ $dataCheck(item.joinTime) }}
                </el-col>
              </el-row>
              <el-row v-if="customerDetail.shopCustomerInfos.length === 0">
                <el-col :span="24">
                  <p class="none-txt">{{ $t('customer::customer-list::customer_no_consume') }}</p>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-row>
        <el-row class="mb10">
          <el-card>
            <div slot="header" class="header-wrap">
              <span>
                {{ $t('customer::customer-list::customer_tag') }}
                <!-- <span class="tips">{{ $t('customer::customer-list::ten_limit_max') }}</span> -->
              </span>
            </div>
            <div style="padding: 8px 0">
              <el-tag :disable-transitions="false" style="margin: 0 10px 10px 0" v-if="customerDetail.userType">
                {{ customerDetail.userType }}
              </el-tag>
              <!-- <el-popover
                ref="tagPopover"
                placement="top-start"
                :title="$t('customer::customer-list::add_tag')"
                width="200"
                trigger="click"
                @show="initTags"
              >
                <el-select
                  :placeholder="$t('customer::customer-list::select_tag')"
                  v-model="tempTag"
                  style="width: 100%"
                  multiple
                  collapse-tags
                  :multiple-limit="10"
                >
                  <el-option v-for="item in tagList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <div>
                  <el-button type="primary" style="width: 100%;margin-top:10px" @click="changeTags">
                    {{ $t('customer::customer-list::confirm') }}
                  </el-button>
                </div>
                <el-button slot="reference" type="small" icon="el-icon-plus">
                  {{ $t('customer::customer-list::select_tag_btn') }}
                </el-button>
              </el-popover> -->
            </div>
          </el-card>
        </el-row>
      </el-col>
      <el-col :xl="10" :lg="24">
        <el-card>
          <div slot="header" class="header-wrap">
            <span>{{ $t('customer::customer-list::detail_info') }}</span>
          </div>
          <div style="padding: 32px 8px">
            <div class="detail-info">
              <div class="line-left">{{ $t('customer::customer-list::join_time') }}：</div>
              {{ $dataCheck(customerDetail.joinTime) }}
            </div>
            <div class="detail-info">
              <div class="line-left">{{ $t('customer::customer-list::first_order_time') }}：</div>
              {{ $dataCheck(customerDetail.firstOrderTime) }}
            </div>
            <div class="detail-info">
              <div class="line-left">{{ $t('customer::customer-list::lastOrderTime') }}：</div>
              {{ $dataCheck(customerDetail.lastOrderTime) }}
            </div>
            <div class="detail-info">
              <div class="line-left">{{ $t('customer::customer-list::buy_count') }}：</div>
              <div>{{ $dataCheck(customerDetail.orderNum) }} {{ $t('customer::customer-list::times') }}</div>
            </div>
            <div class="detail-info">
              <div class="line-left">{{ $t('customer::customer-list::qty') }}：</div>
              {{ $dataCheck(customerDetail.qty) }} {{ $t('customer::customer-list::件') }}
            </div>
            <div class="detail-info">
              <div class="line-left">{{ $t('customer::customer-list::ltv') }}：</div>
              <div>{{ $dataCheck(formatNumberMix(customerDetail.ltv, 2)) }} USD</div>
            </div>
            <!-- <div class="detail-info">
              <div class="line-left">{{ $t('customer::customer-list::after_sale_refund') }}：</div>
              <div>{{ $dataCheck(customerDetail.refundOrderCount) }} {{ $t('customer::customer-list::times') }}</div>
            </div> -->
          </div>
        </el-card>
      </el-col>
    </el-row>
    <edit-dialog v-model="visiable" :row="customerDetail" @submit="getDetail"></edit-dialog>
  </div>
</template>

<script>
import { formatNumberMix } from '@/utils'
import EditDialog from '@/views/customer/components/editDialog'
// import { getCustomerDetail, editCustomer } from '@/server/customers'
import { getCustomerDetail, getCustomerRegister } from '@/server/etl'
import { getDicByCode } from '@/server/common'
export default {
  name: 'tab-info',
  components: { EditDialog },
  data() {
    return {
      loading: false,
      customerDetail: {
        shopCustomerInfos: [],
      },
      visiable: false,
      tagList: [],
      tempTag: [],
    }
  },
  activated() {
    this.getDetail()
  },
  // async created() {
  //   this.getDetail()
  //   // const tag = await getDicByCode(8)
  //   // if (tag.data.code === this.$code) {
  //   //   this.tagList = tag.data.data
  //   // }
  // },
  methods: {
    formatNumberMix,
    async getDetail() {
      const params = {
        userEmail: this.$route.params.email,
        orgUnitId: this.$store.state.user.merchantId,
      }
      this.loading = true
      const [info, reg] = await Promise.all([getCustomerDetail(params), getCustomerRegister(params)])
      this.loading = false
      if (info.data.code === this.$code) {
        this.customerDetail = { ...this.customerDetail, ...(info.data.data.datas.length && info.data.data.datas[0]) }
      }
      if (info.data.code === this.$code) {
        this.customerDetail.shopCustomerInfos = (reg.data.data && reg.data.data.datas) || []
      }
    },
    async editMarket(value) {
      const params = {
        ...this.customerDetail,
        accepts_marketing: value ? 1 : 0,
      }
      this.editDetail(params).then(_ => {
        this.$message.success(
          `${
            value
              ? this.$t('customer::customer-list::subscribe_success')
              : this.$t('customer::customer-list::cancel_subscribe_success')
          }`
        )
      })
    },
    async editDetail(params) {
      this.loading = true
      const { data } = await editCustomer({ ...params })
      this.loading = false
      return new Promise(resolve => {
        if (data.code === this.$code) {
          this.getDetail()
          resolve()
        }
      })
    },
    handleClose(tag) {
      const params = {
        ...this.customerDetail,
        customerTagIds: [...this.customerDetail.customerTags]
          .filter(item => item.customerTagId !== tag.customerTagId)
          .map(i => i.customerTagId),
      }
      this.editDetail(params).then(_ => {
        this.$message.success(this.$t('customer::customer-list::delete_tag_success'))
      })
    },
    initTags() {
      this.tempTag = (this.customerDetail.customerTags || []).map(item => item.customerTagId)
    },
    changeTags() {
      const params = {
        ...this.customerDetail,
        customerTagIds: [...this.tempTag],
      }
      this.editDetail(params).then(_ => {
        this.$message.success(this.$t('customer::customer-list::edit_tag_success'))
        this.$refs.tagPopover.doClose()
      })
    },
  },
  // watch: {
  //   '$route.query'(val) {
  //     if (val.email !== this.customerDetail.userEmail) {
  //       this.getDetail()
  //     }
  //   },
  // },
}
</script>

<style lang="scss" scoped>
/deep/.el-card__header {
  border-bottom: 1px solid #dcdfe6;
  line-height: 1;
  height: auto;
  padding: 22px 24px;
}
.header-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  & span {
    font-size: 18px;
    font-weight: bold;
  }
  .tips {
    font-weight: normal;
    font-size: 14px;
    color: #aaaaaa;
    margin-left: 10px;
  }
}
.line-item {
  display: flex;
  width: 50%;
  .line-left {
    width: 100px;
    text-align: right;
    font-size: 14px;
    color: #010517;
    & span {
      color: red;
    }
  }
  .content {
    margin-left: 8px;
    word-break: break-all;
    flex: 1;
  }
}
.shop-line + .shop-line {
  margin-top: 24px;
}
.shop-main {
  word-break: break-all;
}
.none-txt {
  color: #aaa;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.tag-wrap {
  width: 80%;
  border-radius: 5px;
  border: 1px solid rgba(215, 215, 215, 1);
  padding: 10px 20px 0 20px;
}
.detail-info {
  display: flex;
  .line-left {
    // width: 70px;
    margin-right: 8px;
  }
}
.detail-info + .detail-info {
  margin-top: 24px;
}
// .tag-style {
//   height: 32px;
//   margin: 0 10px 10px 0;
// }
</style>
